import api from './api'; // Import Axios instance
import { logout } from './authService';

//POST to the Forgot Password endpoint
export const forgotPassword = async (email) => {
    try {
        const response = await api.post('/user/forgotPassword', {
            EmailAddress: email
        });
        const userProfileData = response.data.payload;
        return userProfileData;

    } catch (error) {
        console.error(error);
        logout();
        window.location.href = '/';
    }
};

// Get logged in user profile data
export const getLoggedInUserProfile = async () => {
    try {
        const response = await api.get('/user');

        const userProfileData = response.data.payload;
        return userProfileData.profile;

    } catch (error) {
        console.error(error);
        logout();
        window.location.href = '/';
    }
};

export const updateUserProfileData = async (patchData) => {
    try {
        const response = await api.patch("/user/profile", patchData, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        const updatedUser = response.data.payload;
        return updatedUser;

    } catch (error) {
        console.error(error);
    }
};

export const getUserById = async (userId) => {
    try {
        const response = await api.get(`/user/id/${userId}`);

        const userProfileData = response.data.payload;
        return userProfileData;

    } catch (error) {
        console.error(error);
    }
};


export const updatePassword = async (formData) => {
    try {
        const response = await api.put(`/user/password`, formData);

        const apiResponse = response;
        return apiResponse;

    } catch (error) {
        console.error(error);
    }
};